<template>
  <div class="mf-card benefit-group-card-container">
    <span class="offer-type-name" style="text-transform: capitalize">{{ offerTypeName }}</span>
    <v-divider class="my-4"></v-divider>
    <div class="vertical-grouping">
      <div class="details">
        <div class="benefit-title-and-tooltip">
          <span v-if="!isZeDeliveryCampaign" class="benefit-details-title">
            <span style="text-transform: capitalize">{{ offerTypeName }}</span> gerado (R$)
          </span>
          <span v-else>
            <span class="benefit-details-title">Desconto aplicado (R$)</span>
          </span>

          <tooltip align="bottom" max-width="192px" variant="secondary" :disabled="isVoucherDigital || isZeDeliveryCampaign" :message="tooltipMessage">
            <mf-icon v-show="!isVoucherDigital && !isZeDeliveryCampaign" small>info</mf-icon>
          </tooltip>
        </div>

        <mf-loading v-if="loading" style="height: 52px" :booleanLoader="loading" loaderType="dynamic" />
        <div v-else>
          <span class="benefit-details-value" :class="isZeDeliveryCampaign ? 'text-verde-0' : ''">{{
            localeString(isZeDeliveryCampaign ? consumedZeDiscounts : earn, 2) | currency
          }}</span>
          <div v-if="isZeDeliveryCampaign && !isFranchisee" class="benefits-additional-text">
            <span>Total de vouchers gerados: {{ localeString(activatedZeDiscounts, 2) | currency }}</span>
          </div>
        </div>
      </div>
      <v-divider vertical class="mr-4 ml-4"></v-divider>

      <div v-if="isZeDeliveryCampaign && isFranchisee" class="details">
        <span class="benefit-details-title">Quantidade de vouchers utilizados</span>
        <mf-loading v-if="loading" style="height: 52px" :booleanLoader="loading" loaderType="dynamic" />
        <div v-else>
          <span class="benefit-details-value">{{ localeString(consumedZeVouchers, 0) }}</span>
        </div>
      </div>

      <div v-else class="details">
        <span class="benefit-details-title">Clientes que ganharam {{ offerTypeName }}</span>
        <mf-loading v-if="loading" style="height: 52px" :booleanLoader="loading" loaderType="dynamic" />
        <div v-else>
          <span class="benefit-details-value">{{ localeString(isZeDeliveryCampaign ? activatedZeClients : earnClients, 0) }}</span>
          <div class="benefits-additional-text">
            <span>Média por cliente: {{ isZeDeliveryCampaign ? activatedZeClientsAverage : earnClientsAverage }} {{ offerTypeName }}</span>
          </div>
        </div>
      </div>
      <v-divider vertical class="mr-4 ml-4"></v-divider>

      <div class="details">
        <span class="benefit-details-title">Clientes que utilizaram {{ offerTypeName }}</span>

        <mf-loading v-if="loading" style="height: 52px" :booleanLoader="loading" loaderType="dynamic" />
        <div v-else>
          <span class="benefit-details-value">{{ localeString(isZeDeliveryCampaign ? consumedZeClients : burnClients, 0) }}</span>
          <div class="benefits-additional-text">
            <span>Média por cliente: {{ isZeDeliveryCampaign ? consumedZeClientsAverage : burnClientsAverage }} {{ offerTypeName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

export default {
  name: 'BenefitGroupCard',
  components: {
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    loading: Boolean,
    metrics: {
      type: Object,
      default(_) {
        return {}
      },
    },
    offerType: {
      type: String,
      validator: (value) => ['nextbuycashback', 'dynamic_rule', 'cashback_absolute', 'cashback_percentage', 'benefits'].includes(value),
    },
  },
  computed: {
    activatedZeDiscounts() {
      return this.metrics?.benefits_metrics_totals_activated?.discounts || 0
    },
    activatedZeClients() {
      return this.metrics?.benefits_metrics_totals_activated?.clients || 0
    },
    consumedZeDiscounts() {
      return this.metrics?.benefits_metrics_totals_consumed?.discounts || 0
    },
    consumedZeClients() {
      return this.metrics?.benefits_metrics_totals_consumed?.clients || 0
    },
    consumedZeVouchers() {
      return this.metrics?.benefits_metrics_totals_consumed?.quantity || 0
    },
    activatedZeClientsAverage() {
      return this.activatedZeClients === 0 ? 0 : localeString(this.metrics?.benefits_metrics_totals_activated?.quantity / this.activatedZeClients, 2)
    },
    consumedZeClientsAverage() {
      return this.consumedZeClients === 0 ? 0 : localeString(this.metrics?.benefits_metrics_totals_consumed?.quantity / this.consumedZeClients, 2)
    },

    earn() {
      return this.metrics?.earn_metrics?.total_value || 0
    },
    earnClients() {
      return this.metrics?.earn_metrics?.clients || 0
    },
    burnClients() {
      return this.metrics?.burn_metrics?.clients || 0
    },
    earnClientsAverage() {
      return this.earnClients === 0 ? 0 : localeString(this.metrics?.earn_metrics?.count / this.earnClients, 2)
    },
    burnClientsAverage() {
      return this.burnClients === 0 ? 0 : localeString(this.metrics?.burn_metrics?.count / this.burnClients, 2)
    },

    isZeDeliveryCampaign() {
      return this.offerType === 'benefits'
    },
    isVoucherDigital() {
      return this.offerType === 'dynamic_rule'
    },
    offerTypeName() {
      switch (this.offerType) {
        case 'nextbuycashback':
        case 'cashback_absolute':
        case 'cashback_percentage':
          return 'cashback'
        case 'dynamic_rule':
        case 'benefits':
          return 'voucher'
        default:
          return ''
      }
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    tooltipMessage() {
      return `Total de ${this.offerTypeName} concedidos através dos produtos vendidos na oferta`
    },
  },
  methods: {
    localeString,
  },
}
</script>

<style lang="scss" scoped>
.benefit-group-card-container {
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  height: 100%;

  .offer-type-name {
    font-size: 22px;
    font-weight: bold;
    color: $cinza-d10;
  }

  .vertical-grouping {
    display: flex;
    flex-direction: row;
    gap: 12px;
    overflow: hidden;
    text-overflow: ellipsis;

    .details {
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: 16px;

      .benefit-title-and-tooltip {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 6px;
      }

      .benefit-details-title {
        font-size: 16px;
        color: $cinza-0;
      }

      .benefit-details-value {
        font-size: 26px;
        color: $cinza-d10;
        font-weight: bold;
      }

      .text-verde-0 {
        color: $verde-0;
      }

      .benefits-additional-text {
        margin-top: 8px;
        font-size: 12px;
        color: $cinza-0;
      }
    }
  }
}
</style>
